import { c as _c } from "react/compiler-runtime";
import { Stack, Text } from "@chakra-ui/react";
interface ReportAddressProps {
  searchedAddress: string | null;
}
const ReportAddress: React.FC<ReportAddressProps> = t0 => {
  const $ = _c(5);
  const {
    searchedAddress
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "row",
      xl: "row"
    };
    t2 = {
      base: "flex-start",
      md: "center"
    };
    t3 = {
      base: "1",
      md: "1"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== searchedAddress) {
    t4 = <Stack direction={t1} alignItems={t2} gap={t3}><Text textStyle="headerMedium" layerStyle="headerMain">Report for {searchedAddress}</Text></Stack>;
    $[3] = searchedAddress;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default ReportAddress;